import { AbTestVariants } from '@app/store/ui'
import { getLDFlag } from '@app/utils/parseLdSSRFlags'

import { originalFlow } from './originalFlow'
import { selfServeFlow } from './selfServeFlow'
import { UnifiedBookingFlowLaunchDarklyFlags } from './types'

export * from './originalFlow'
export * from './selfServeFlow'

// These are all the available workflows, not the ones running.
// See app/constants/index.ts for details.
// These are all the available workflows, not the ones running.
export const allBookingFlows = {
  default: [originalFlow],
  faCallOptional: [selfServeFlow]
}

// returns the originalFlow (Control) by default
export const getBookingFlow = (
  testVariantId: AbTestVariants | undefined | null,
  ldFlags?: UnifiedBookingFlowLaunchDarklyFlags
) => {
  const faFlag = getLDFlag('bookingFaCallOptional') || ldFlags?.bookingFaCallOptional
  const flags = ldFlags || {}

  const allFlows = (faFlag ? allBookingFlows.faCallOptional : allBookingFlows.default).map(t => t(flags))

  return allFlows.find(t => t.testVariantId === testVariantId) || allFlows[0]
}
